import React from "react";

import { LoginContent } from "src/content";

const Login = () => {
  return (
    <div>
      <LoginContent />
    </div>
  );
};

export default Login;
